.toggle {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
}

.input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.track {
  position: relative;
  flex: 0 0 auto;
  width: 56px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid #cfcfcf;
  background: #fff;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;
}

.thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: left 0.2s ease;
}

/* OFF / ON label sits on the side opposite the thumb. */
.state {
  position: absolute;
  top: 0;
  right: 8px;
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #999;
}

.input:checked ~ .track {
  background: #2ca6d6;
  border-color: #2ca6d6;
}

.input:checked ~ .track .thumb {
  left: 34px;
}

.input:checked ~ .track .state {
  right: auto;
  left: 8px;
  color: #fff;
}

.input:focus-visible ~ .track {
  outline: 2px solid #2ca6d6;
  outline-offset: 2px;
}

.label {
  font-size: 14px;
  font-weight: 700;
  color: #222;
}
